import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { IExperiment } from '../model/experiment/Experiment';
import { useParams } from 'react-router-dom';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useExperimentResult {
    isLoaded: boolean;
    experiment: IExperiment | null;
}

export const useExperiment = (refreshToken: boolean) => {

    const rootStore = useContext(RootStoreContext);
    const params = useParams<{ experimentId: string }>();
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useExperimentResult>({
        isLoaded: false,
        experiment: null
    });

    useEffect(() => {
        setResult({ isLoaded: false, experiment: null });

        if (params.experimentId) {
            rootStore.experimentStore.getExperiment(parseInt(params.experimentId))
                .then((experiment) => {
                    if (!experiment.inAnyDistribution)
                        experiment.updateSpecificationsToToLatestVersion();
                    setResult({ isLoaded: true, experiment: experiment });
                })
                .catch(e => publishNotification({
                    text: `Error loading experiment: ${e.message}`,
                    canClose: true
                }));
        } else {
            setResult({ isLoaded: true, experiment: rootStore.experimentStore.addExperiment() });
        }
    }, [rootStore.experimentStore, publishNotification, params.experimentId, refreshToken]);

    return result;
};
